import React from 'react';
interface FooterProps {
  onOpenModal: (type: 'privacy' | 'contact' | 'terms') => void;
}
export function Footer({
  onOpenModal
}: FooterProps) {
  return <footer className="bg-[#1a1a1a] text-white py-8 px-4" data-id="element-50">
      <div className="max-w-6xl mx-auto" data-id="element-51">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-52">
          <div className="text-sm text-white/70" data-id="element-53">
            © 2024 finance-time.net. All rights reserved.
          </div>
          <div className="flex flex-wrap justify-center gap-6" data-id="element-54">
            <button onClick={() => onOpenModal('privacy')} className="text-sm text-white/80 hover:text-white transition-colors underline" data-id="element-55">
              Privacy Policy
            </button>
            <button onClick={() => onOpenModal('contact')} className="text-sm text-white/80 hover:text-white transition-colors underline" data-id="element-56">
              Contact Us
            </button>
            <button onClick={() => onOpenModal('terms')} className="text-sm text-white/80 hover:text-white transition-colors underline" data-id="element-57">
              Terms of Use
            </button>
          </div>
        </div>
      </div>
    </footer>;
}